module.exports = __webpack_public_path__ + "media/images/icon/1-81dfd800941168c714a5815ed4f0b5e1.svg";